import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestVideos() {
  const { t } = useTranslation();
  const latestVideos = [...videos].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime());

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              {t('home.latestTitle')}
            </h2>
            <p className="mt-1 text-sm text-foreground-500">最新上线的热门视频</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} size="small" />
          ))}
        </div>
      </div>
    </section>
  );
}